export default __webpack_public_path__ + "static/media/music-note.0ef72478.svg";